import {Component} from 'react'
import Ad from "./ads/InPlayer"
import {connect} from 'react-redux'
import {videoView} from '../redux/actions'
import load from 'load-script'

class Player extends Component {
    constructor(props) {
        super(props)
        this.play = this.play.bind(this)
        this.ad = this.ad.bind(this)
        this.mountPlayer = this.mountPlayer.bind(this)
        this.mountVideoPlayer = this.mountVideoPlayer.bind(this);
        this.mountVideoEmbed = this.mountVideoEmbed.bind(this);
        this.state = {
            showAd: true
        }
    }

    componentDidMount() {
        this.props.dispatch(videoView(this.props.id))
        this.mountPlayer()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.props.dispatch(videoView(this.props.id))
            this.mountPlayer()
        }
    }

    mountVideoEmbed() {
        if (this.props.embed) {
            let re = new RegExp('src="(.*)"'),
                res = re.exec(this.props.embed);
            load(res[1]);
        } else if (this.props.playerEmbedUrl) {
            let url = this.props.playerEmbedUrl.replace('{CONTAINER}', 'lj_player');
            load(url);
        }
    }

    mountVideoPlayer() {
        let flashvars = {
            // adv_pre_skip_duration: 4,
            // adv_pre_skip_text: 'Skip',
            // adv_pre_skip_text_time: 'Skip Ad %time',
            // adv_pre_vast: 'https://ca.clcknads.pro/v1/a/22186/imp?resolve_vast=true',
            lrcv: "1550405585773157720125525",
            video_id: this.props.id,
            license_code: '$673366722215546',
            video_url: this.props.files['mp4'].link,
            video_url_text: '540p',
            postfix: 'mp4',
            skin: 'youtube.css',
            bt: 18,
            volume: 1,
            preload: 'metadata',
            hide_controlbar: '1',
            hide_style: 'fade',
            preview_url: this.props.poster
        }
        let params = {allowfullscreen: 'true', allowscriptaccess: 'always'}

        if (this.props.files['hd.mp4']) { // support format choosing in KVS player
            flashvars.video_alt_url = this.props.files['hd.mp4'].link;
            flashvars.video_alt_url_text = '720p';
            flashvars.video_alt_url_hd = '1';
        }

        this.playerObj = kt_player('kt_player', '/static/player/kt_player.swf', '1280', '755', flashvars, params)
        this.playerObj.listen('ktVideoStarted', function() {
            this.setState({showAd: false})
        }.bind(this))
        this.playerObj.listen('ktVideoPaused', function() {
            this.setState({showAd: true})
        }.bind(this))
    }

    mountPlayer() {
        if (this.props.files) {
            this.mountVideoPlayer();
        } else if (this.props.embed || this.props.playerEmbedUrl) {
            this.mountVideoEmbed();
        }
    }

    play() {
        this.playerObj.play()
    }

    ad() {
        return this.props.device === 'desktop' && this.state.showAd ?
            <Ad play={this.play} /> :
            null
    }

    render() {
        if (this.props.files) {
            return (
                <div className="video-holder">
                    <div id="kt_player" style={{visibility: "hidden"}}>
                        <a href="http://adobe.com/go/getflashplayer">This page requires Adobe Flash Player</a>
                    </div>
                    {this.ad()}
                </div>
            );
        } else if (this.props.embed || this.props.playerEmbedUrl) {
            return (
                <div className="video-holder">
                    <div id="lj_player" data-awe-container-id="lj_player" >
                        &nbsp;
                    </div>
                </div>
            )
        }
    }
}

export default connect()(Player)



// WEBPACK FOOTER //
// components/Player.js